import { CentralProfileLink } from './CentralAccounts';
export default function CancelPasswordReset() { return <CentralProfileLink path="/identity-email" />; }
